import React, { Component } from 'react';
import { connectDeep } from 'redux-utils';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ContentBlock, SectionTitle } from 'components/Common';
import ErrorPage from 'components/ErrorPage';
import Layout from 'components/Layout';
import LoadingPage from 'components/LoadingPage';

import App from 'models/app';
import i18n from 'i18n';

import { savePermissions, triggerUpdateAppPermissions } from 'actions/gallery';
import { updatePermissions } from 'actions/registry';
import PermissionsEditor from './PermissionsEditor';

const Container = ({ children }) => (
  <Layout
    backText={i18n('page.Permission.backText')()}
    center={i18n('page.Permission.center')()}
    name="Permissions"
    pageElement={children}
  />
);

Container.propTypes = {
  backText: PropTypes.string
};

const Subtitle = styled.div`
  color: gray;
  font-size: 14px;
  margin: 8px 15px;
`;

class PermissionsPage extends Component {
  static propTypes = {
    app: PropTypes.shape(),
    savePermissions: PropTypes.func.isRequired
  };

  onChange = async (grantedPermissions) =>
    this.props.savePermissions(this.props.app.id, grantedPermissions);

  render() {
    const { app, loading, error } = this.props;

    if (loading || !app) {
      return (
        <Container>
          <LoadingPage headerHeight={56} />
        </Container>
      );
    }
    if (error || !app || !app.grantedPermissions) {
      return (
        <Container>
          <ErrorPage />
        </Container>
      );
    }

    return (
      <Container>
        <SectionTitle>
          {i18n('page.Permission.title')({ appName: app.name })}
        </SectionTitle>
        <ContentBlock>
          <PermissionsEditor app={app} onChange={this.onChange} />
        </ContentBlock>
        <Subtitle>{i18n('page.Permission.subtitle')()}</Subtitle>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    app: { loading, error, entry }
  } = state.registry;

  let app;
  if (entry) {
    app = App.selectFromState(entry, state);
  }

  return {
    app,
    loading,
    error
  };
};

const mapDispatchToProps = (dispatch) => ({
  savePermissions: async (appId, grantedPermissions) => {
    dispatch(
      savePermissions({
        appId,
        grantedPermissions
      })
    );
    await dispatch(updatePermissions(appId));
    dispatch(triggerUpdateAppPermissions());
  }
});

export default connectDeep(
  mapStateToProps,
  mapDispatchToProps
)(PermissionsPage);
